
import { FloatingSettingSearchType } from '../constants';
import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class PlacementSearchParam extends CommonSearchParam {

  constructor(
    mode?: 'link',
    keyword?: string,
    type?: number,
    publisherName?: string,
    siteName?: string,
    pageName?: string,
    floatingSettingSearchType?: FloatingSettingSearchType,
    ids?: number[]
  ) {
    super();
    this.keyword = keyword;
    this.type = type;
    this.publisherName = publisherName;
    this.siteName = siteName;
    this.pageName = pageName;
    this.mode = mode;
    this.floatingSettingSearchType = floatingSettingSearchType;
    this.ids = ids;
  }

  @ApiBind({ column: 'search_keyword' })
  keyword: string;

  @ApiBind({ column: 'type' })
  type: number;

  @ApiBind({ column: 'publisher_name' })
  publisherName: string;

  @ApiBind({ column: 'site_name' })
  siteName: string;

  @ApiBind({ column: 'page_name' })
  pageName: string;

  @ApiBind({ column: 'mode' })
  mode: string;

  @ApiBind({ column: 'floating_setting_search_type' })
  floatingSettingSearchType: FloatingSettingSearchType;

  @ApiBind({ column: 'ids' })
  ids: number[];
}
